import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "@/views/HomeView.vue";
import ShiftSwitcher from "@/views/ShiftsView.vue";
import AgentListing from "@/views/AgentListing.vue";
import AccountView from "@/views/AccountView.vue";
import UsersView from "@/views/UsersView.vue";
import SkipsView from "@/views/SkipsView.vue";
import StatsView from "@/views/StatsView.vue";
import LogsView from "@/views/LogsView.vue";
import ChangeLog from "@/views/ChangeLog.vue";
import ServiceStatus from "@/views/ServiceStatus.vue";
import FiltersView from "@/views/FiltersView.vue";
import QueuesView from "@/views/QueuesView.vue";
import TicketHistoryView from "@/views/TicketHistoryView.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: HomeView,
    meta: {
      icon: "mdi-home",
    },
  },
  {
    path: "/agents",
    name: "Agents",
    component: AgentListing,
    meta: {
      icon: "mdi-account-group",
    },
  },
  {
    path: "/shift-switcher",
    name: "Shifts",
    component: ShiftSwitcher,
    meta: {
      icon: "mdi-calendar",
    },
  },

  {
    path: "/skips",
    name: "Skips",
    component: SkipsView,
    meta: {
      icon: "mdi-alarm-off",
    },
  },
  {
    path: "/stats",
    name: "Stats",
    component: StatsView,
    meta: {
      icon: "mdi-chart-pie",
    },
  },

  {
    path: "/service-status",
    name: "Service Status",
    component: ServiceStatus,
    meta: {
      icon: "mdi-monitor",
    },
  },
  {
    path: "/queues",
    name: "Queues",
    component: QueuesView,
    meta: {
      icon: "mdi-format-list-bulleted",
    },
  },
  {
    path: "/filters",
    name: "Filters",
    component: FiltersView,
    meta: {
      icon: "mdi-filter",
    },
  },
  {
    path: "/ticket-history",
    name: "Ticket History",
    component: TicketHistoryView,
    meta: {
      icon: "mdi-history",
    },
  },
  {
    path: "/change-log",
    name: "Change Log",
    component: ChangeLog,
    meta: {
      icon: "mdi-information",
    },
  },
  {
    path: "/logs",
    name: "Logs",
    component: LogsView,
    meta: {
      icon: "mdi-file-document",
    },
  },
  {
    path: "/users",
    name: "Users",
    component: UsersView,
    meta: {
      icon: "mdi-account-settings",
    },
  },
  {
    path: "/account",
    name: "Account",
    component: AccountView,
    meta: {
      icon: "mdi-account",
    },
  },
];

const router = new VueRouter({
  routes,
});

export default router;
